import React, { useState } from 'react';
import { Plus } from 'lucide-react';

export const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="border border-[#e8ff00]/10 mb-2 overflow-hidden transition-all hover:border-[#e8ff00]/25">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-5 py-4 bg-zinc-900 text-left flex justify-between items-center hover:bg-zinc-800 transition-colors"
      >
        <span className="text-white text-sm font-medium pr-4">{question}</span>
        <Plus className={`w-4 h-4 text-[#e8ff00] transition-transform flex-shrink-0 ${isOpen ? 'rotate-45' : ''}`} />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96' : 'max-h-0'}`}>
        <div className="px-5 pb-4 text-zinc-400 text-sm leading-relaxed">{answer}</div>
      </div>
    </div>
  );
};
